import { fromRange } from 'xpath-range';

const MIN_SELECTION_LENGTH = 7;

function getSelection() {
  return window.getSelection();
}

const getXpathParameters = (xpath: any) => {
  const startOffset = xpath.startOffset;
  const endOffset = xpath.endOffset;
  let startContainer = xpath.start;
  // /div[2]/p[7]/text()[1] -> /div[2]/p[7]/text[1]
  startContainer = startContainer.replace(/(|)/g, '');
  let endContainer = xpath.end;
  endContainer = endContainer.replace(/(|)/g, '');
  return { startOffset, endOffset, startContainer, endContainer };
};

export function onHighlightAction(
  color: string,
  saveUserAnnotation: (annotation: any) => void,
  el: any,
) {
  const selection = getSelection();

  if (!selection) {
    return;
  }

  if (selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    const content = el;
    let xpath = null;
    if (content) {
      xpath = fromRange(range, content);
    }
    if (xpath) {
      const text = selection.toString();
      if (text.length < MIN_SELECTION_LENGTH) {
        return;
      }
      try {
        let { startOffset, endOffset, startContainer, endContainer } =
          getXpathParameters(xpath);
        saveUserAnnotation({
          text,
          color,
          startOffset,
          endOffset,
          startContainer,
          endContainer,
        });
      } catch (e) {
        console.error('user highlight failed: ', e);
      }
    }
  }
}
